import axios from 'axios';
import type { LeadPayload } from '../lib/validators/contact';

const leadApi = axios.create({
    baseURL: 'https://www.speakingclub.ua/api',
});

export async function createLead(payload: LeadPayload) {
    const res = await leadApi.post('/leads', payload);
    return res.data;
}

export async function createMonoPayment({
    amount,
    title,
    orderId,
    destination,
    redirectUrl,
    webHookUrl,
}: {
    amount: number;
    title: string;
    orderId?: string;
    destination?: string;
    redirectUrl?: string;
    webHookUrl?: string;
}) {
    // Align payload with the other project's Monobank request shape
    const res = await axios.post('/api/create-mono-payment', {
        amount,
        ccy: 980, // UAH
        merchantPaymInfo: {
            reference: orderId,
            destination: destination ?? title,
            comment: title,
            basketOrder: [],
        },
        redirectUrl,
        webHookUrl,
    });
    return res.data;
}

export async function createLiqpayPayment({
    amount,
    title,
    orderId,
    redirectUrl,
}: {
    amount: number;
    title: string;
    orderId?: string;
    redirectUrl?: string;
}) {
    const res = await axios.post('/api/create-liqpay-payment', {
        amount,
        title,
        orderId,
        redirectUrl,
    });
    return res.data;
}
